import PropTypes from 'prop-types';
import { Box, Button, Typography } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useTranslation } from 'react-i18next';

const breadcrumbButtonStyles = {
    minWidth: 0,
    p: 0,
    color: '#101418',
    fontSize: '1.5rem',
    fontWeight: 700,
    textTransform: 'none'
};

const currentLabelStyles = {
    color: '#60717B',
    fontSize: '1.5rem',
    fontWeight: 600
};

const PatientSectionHeading = ({
    sectionLabel,
    detailLabel,
    onBack,
    onSectionBack,
    action
}) => {
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: 1.5,
                minHeight: 44,
                mb: 1.5
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
                {sectionLabel ? (
                    <>
                        <Button onClick={onBack} sx={breadcrumbButtonStyles}>
                            {t('userPage.sections.general')}
                        </Button>
                        <ChevronRightIcon
                            sx={{ mx: 0.75, color: '#60717B', fontSize: 30 }}
                        />
                        {detailLabel ? (
                            <>
                                <Button
                                    onClick={onSectionBack}
                                    sx={breadcrumbButtonStyles}
                                >
                                    {sectionLabel}
                                </Button>
                                <ChevronRightIcon
                                    sx={{ mx: 0.75, color: '#60717B', fontSize: 30 }}
                                />
                                <Typography component="h1" sx={currentLabelStyles}>
                                    {detailLabel}
                                </Typography>
                            </>
                        ) : (
                            <Typography component="h1" sx={currentLabelStyles}>
                                {sectionLabel}
                            </Typography>
                        )}
                    </>
                ) : (
                    <Typography
                        component="h1"
                        sx={{ color: '#101418', fontSize: '1.5rem', fontWeight: 700 }}
                    >
                        {t('userPage.sections.general')}
                    </Typography>
                )}
            </Box>
            {action && <Box sx={{ ml: 'auto' }}>{action}</Box>}
        </Box>
    );
};

PatientSectionHeading.propTypes = {
    action: PropTypes.node,
    sectionLabel: PropTypes.string,
    detailLabel: PropTypes.string,
    onSectionBack: PropTypes.func,
    onBack: PropTypes.func.isRequired
};

export default PatientSectionHeading;
